import React from 'react';
import { Alert } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
var CustomerListItemAvatar = function (_a) {
    var _b = _a.customer, firstName = _b.firstName, lastName = _b.lastName, phoneNumber = _b.phones[0].phoneNumber;
    var getDetailsMessage = function () {
        if (!(firstName || lastName || phoneNumber))
            return ' Please try filtering by First Name, Last Name or Phone Number.';
        var details = [];
        var detailsMessage = ' Please try changing your filter';
        if (firstName)
            details.push('First Name');
        if (lastName)
            details.push('Last Name');
        if (phoneNumber)
            details.push('Phone Number');
        detailsMessage = detailsMessage.concat(details.length > 1 ? 's to ' : ' to ');
        detailsMessage =
            details.length > 2
                ? detailsMessage
                    .concat(details.slice(0, details.length - 1).join(', '))
                    .concat(" or ".concat(details.slice(details.length - 1, details.length)))
                : detailsMessage.concat(details.join(' or '));
        return "".concat(detailsMessage, ".");
    };
    return (React.createElement(Alert, { icon: React.createElement(InfoIcon, { fontSize: "inherit" }), severity: "warning", variant: "filled" }, "No customers were found.".concat(getDetailsMessage())));
};
export default CustomerListItemAvatar;
//# sourceMappingURL=CustomerListAlert.js.map